import { Suspense, lazy, type ReactNode } from "react";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AboutPanel } from "@/components/AboutPanel";
import { LoadingScreen } from "@/components/LoadingScreen";

const PhaserGame = lazy(() =>
  import("@/game/PhaserGame").then((m) => ({ default: m.PhaserGame })),
);

export function App(): ReactNode {
  return (
    <ErrorBoundary>
      <div data-testid="app-root">
        <Suspense fallback={<LoadingScreen message="Initializing..." />}>
          <PhaserGame />
        </Suspense>
        <AboutPanel />
      </div>
    </ErrorBoundary>
  );
}
